import axios, {AxiosError, isAxiosError, AxiosHeaders} from 'axios';

import {apiUrlV2} from '../../../utils/constants';

const api = axios.create({
  baseURL: apiUrlV2,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface CheckoutResponse {
  sessionId: string;
  url: string;
  amount: number;
  currency: string;
  requestId: string;
  message: string;
}

export interface CheckoutRequest {
  terminalId: string;
  requestId: string;
  amount: number;
  currency: string;
  successRedirectUrl: string;
  errorRedirectUrl: string;
  webhookUrl: string;
}

export const checkout = async (
  requestBody: CheckoutRequest,
  headers: AxiosHeaders
): Promise<CheckoutResponse> => {
  try {
    const response = await api.post<CheckoutResponse>(
      '/v1/hosted-checkout/new',
      requestBody,
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const axiosError = error as AxiosError<CheckoutResponse>;
      if (axiosError.response?.data?.message) {
        throw new Error(axiosError.response?.data?.message);
      }
    }
    throw new Error('An unexpected error occurred during checkout');
  }
};
